import { css } from 'styled-components';
import { getAPIConfig } from '@tcp/core/src/utils';

const getPadding = (props) => {
  if (!props.fulfillmentGroup) return '8px 10px;';
  return props.isCartTile ? '8px 0 20px' : '8px 8px 20px';
};
const styles = css`
  .delivery-button {
    position: relative;
    margin-right: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    width: 172px;
    height: 60px;
    border-radius: 6px;
    ${() => {
      const apiConfig = getAPIConfig();
      const { language } = apiConfig;

      if (language === 'es' || language === 'fr') {
        return 'margin-bottom:6px;';
      }
      return '';
    }}
    ${(props) => (props.isNewPJPPDPRedesignEnabled ? 'flex:1;' : '')}
    border: solid 1px ${(props) => props.theme.colors.BORDER.GRAY};
    cursor: pointer;
    &.disable-delivery-methods {
      opacity: 0.5;
      cursor: default;
    }
    .header-pickup-line {
      color: ${(props) => props.colors?.PRIMARY?.DARK};
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        padding: 0 2px;
      }
      @media ${(props) => props.theme.mediaQuery.medium} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      }
    }
    .sub-header-pickup {
      color: ${(props) => props.theme.brandSpecificStyles.DELIVERY_METHOD_SECONDARY_LABEL_COLOR};
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    }
    .sub-header-pickup.text-Capitalize {
      text-transform: capitalize;
    }
    .sub-header-pickup.unavailable-sub-header {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
      color: ${(props) => props.theme.colors.PRIMARY.DARK};
      font-weight: normal;
    }
    .badge-container {
      position: absolute;
      width: 100%;
      top: 47px;
      z-index: 0;
      bottom: auto !important;
      display: flex;
      flex-direction: row;
      justify-content: center;
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        top: 50px;
      }
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        top: ${(props) => (props.isCartTile ? `38px` : `40px;`)};
      }
      .badge {
        color: ${(props) => props.theme.colors.PRIMARY.DARK};
        background-color: #fee800;
        display: block;
        text-align: center;
        border-radius: 6px;
        max-width: 90%;
      }
      .banner-wrapper {
        padding-left: 0px;
      }
      .triangle-left {
        display: none;
      }
      .promo-wrapper {
        background-color: transparent;
        width: 100%;
        padding-left: 2px;
        padding-right: 5px;
      }
      .richtextCss {
        margin-left: 0px;
        width: 100%;
      }
      .richtextCss > div > div > div {
        margin-bottom: 2px;
      }
    }

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: ${(props) => (props.fulfillmentGroup ? '116px' : '101px')};
      height: ${(props) => (props.fulfillmentGroup ? '48px' : '56px')};
      margin-right: 6px;
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
      .sub-header-pickup {
        font-size: 11px;
      }
      .my-bag-edd-text {
        font-size: ${(props) => props.theme.typography.fontSizes.fs11};
      }
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: ${(props) => (props.fulfillmentGroup ? '64px' : '80px')};
      width: 100%;
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    .badge {
      min-width: 104px;
      max-width: 80%;
    }
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    .badge {
      min-width: 84px;
      max-width: 80%;
    }
  }
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    .badge {
      min-width: 79px;
      max-width: 80%;
      font-size: ${(props) => props.theme.typography.fontSizes.fs10};
    }
  }
  .triangle-top {
    display: none;
  }
  .delivery-button.boss {
    margin-right: 0px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) =>
        props.quickViewLabels?.extraPercentOff && props.isCartTile
          ? `&.boss .header-pickup-line {
            line-height: .9
          }`
          : ``};
    }
  }

  .delivery-button.selected {
    box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.12);
    border: ${(props) =>
      !props.checkForOOSForVariant &&
      `solid 3px ${props.theme.brandSpecificStyles.DELIVERY_METHOD_BORDER_COLOR}`};
    outline: solid 3px transparent;
    box-sizing: border-box;
    .badge-container {
      top: 45px;
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        top: ${(props) => (props.isCartTile ? `38px` : `40px;`)};
      }
    }
  }
  .delivery-section {
    display: flex;
    justify-content: flex-start;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: ${(props) => (!props.fulfillmentGroup ? '15px 0px' : '0px')};
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      justify-content: space-between;
      margin-right: 4px;
      padding: ${(props) => (props.fulfillmentGroup ? '12px 0px' : '0px')};
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      justify-content: space-evenly;
      padding: ${(props) => getPadding(props)};
    }
  }
  .delivery-button.button-2 {
    width: 264px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 170px;
    }
  }
  .button-disable-overlay {
    opacity: 0.8;
    background-color: #d8d8d8;
  }
`;

export default styles;
